import { FormControl, Select, MenuItem, Typography } from "@mui/material";
import { CrudOperators } from "@refinedev/core";
import { useFiltersWithContext } from "../filter-context/useFiltersWithContext";
import { useTranslation } from "../../../hooks/useTranslation";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";

type OperatorBasedDropdownFilterProps = {
  name: string;
  labelKey: string;
  options: {
    operator: "null" | "notNull" | "eq" | "contains" | "ncontains";
    label: string;
  }[];
  value: string;
};

export const OperatorBasedDropdownFilter = (
  props: OperatorBasedDropdownFilterProps,
) => {
  const { name, labelKey, options, value } = props;

  const { getFiltersWithName, setFilter, deleteFilter } =
    useFiltersWithContext();
  const { translate } = useTranslation();

  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const handleSelect = (operator: Exclude<CrudOperators, "or" | "and">) => {
    const optionLabel =
      options.find((option) => option.operator === operator)?.label ??
      "filters.placeholders.none";

    setFilter({
      field: name,
      value: value,
      labelInfo: {
        descriptionKey: optionLabel,
      },
      operator: operator,
    });
  };

  const handleClear = (operator: Exclude<CrudOperators, "or" | "and">) => {
    deleteFilter(name, operator);
  };

  const selectedFilters = getFiltersWithName(name);
  const selectedFilterOperator =
    selectedFilters?.length > 0 ? selectedFilters[0][1].operator : null;

  return (
    <FormControl
      fullWidth
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        alignItems: "center",
      }}
    >
      <Typography flex={1}>
        {translate(labelKey, { market: selectedCountry?.countryName })}
      </Typography>
      <Select
        size="small"
        sx={{ minWidth: 200 }}
        value={selectedFilterOperator ?? "default"}
        onChange={(e) => {
          if (selectedFilterOperator) {
            handleClear(selectedFilterOperator);
          }

          if (e.target.value === "default") {
            return;
          } else {
            const value = e.target.value as Exclude<
              CrudOperators,
              "or" | "and"
            >;

            handleSelect(value);
          }
        }}
      >
        <MenuItem value="default">
          <em>{translate("filters.placeholders.none")}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.label} value={option.operator}>
            {translate(option.label, { market: selectedCountry?.countryName })}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
